// Main navigiation smartmenus setup
function setupNav() {
  var $mainMenuState  = jQuery('#navigation__state');
  if ($mainMenuState.length) {
    // animate mobile menu
    $mainMenuState.change(function(e) {
      var $menu = jQuery('#navigation__menu');
      if (this.checked) {
        $menu.hide().slideDown(250, function() {
          $menu.css('display', '');
        });
      } else {
        $menu.show().slideUp(250, function() {
          $menu.css('display', '');
        });
      }
    });

    // hide mobile menu beforeunload
    jQuery(window).bind('beforeunload unload', function() {
      if ($mainMenuState[0].checked) {
        $mainMenuState[0].click();
      }
    });
  }
}

function setupGallery() {
  // Don't setup any sliders if there aren't any
  if (!jQuery(".slider").length) {
    return;
  }

  // Main slider
  jQuery('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    fade: true,
    asNavFor: '.slider-nav',
    mobileFirst: true,
  });

  // Smaller navigation slider
  jQuery('.slider-nav').slick({
    asNavFor: '.slider-for',
    dots: false,
    centerMode: true,
    focusOnSelect: true,
    arrows: false,
    mobileFirst: true,
    variableWidth: true,
    responsive: [
      { // xs
        breakpoint: 100,
        settings: {
          slidesToShow: 2,
          infinite: true,
        }
      },
      { // sm
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
        }
      },
      { // md
        breakpoint: 992,
        settings: {
          slidesToShow: 4,
        }
      }
    ]
  });
}

// Separate function to close dropdown b/c it needs to be close from the
// selection updater
function closeSelectorNavDropdown($inner, $loftSelector) {
  $inner.stop().animate({'height' : 0 }, 250, function() {
    $loftSelector.removeClass('selector__nav--expanded');
    $inner.css('height', '');
  });
}

// Click handler for loft selector dropdown functionality
function selectorNavDropdown() {
	var $this       = jQuery(this), // .loft_selector__title
		$loftSelector = $this.parent(),
		$inner        = jQuery('.selector__nav__inner', $loftSelector);

	if (!$inner.length) {
		return;
	}

	if ($loftSelector.hasClass('selector__nav--expanded')) {
    closeSelectorNavDropdown($inner, $loftSelector);
	} else {
    $loftSelector.addClass('selector__nav--expanded');
    $inner.stop().css('height', 'auto');
    var height = $inner.outerHeight();
    $inner.css('height', 0).animate({ 'height' : height }, 250, function() {
      $inner.css('height', '');
    });
	}
}

// If a user clicks on one of the options in the show only the lofts of that type
function selectorNavUpdate(event) {
  var $this              = jQuery(this), // .selector__nav__inner ul a
      selected_nav_item = "selector__nav__item__" + $this.data("selectedType");

  // Prevent the default click action from occuring
  event.preventDefault();

  // Add the active class to the selected loft type, only used for sm and up
  $this.parents("ul").find("a").removeClass('active');
  $this.addClass('active');

  // To future proof in the case of any additional loft types,
  // go through each `selector__nav__item`, hide the ones not selected and show
  // the selected one. `all` will display all available loft types.
  jQuery(".selector__nav__item").each(function(i) {
    var $nav_item = jQuery(this);

    if( selected_nav_item == "selector__nav__item__all" ) {
      $nav_item.show(200);
    } else if( $nav_item.attr("id") ==  selected_nav_item ) {
      // For the gallery items, display none doesn't give slick the dimensions
      // it needs to calculate the image sizes, changing the height to zero and
      // overflow hidden still allows it to calculte was still being visibly hidden.
      $nav_item.css("height", "auto");
      $nav_item.css("overflow", "visible");

      $nav_item.show(200);
    } else {
      $nav_item.hide(300);
    }
  });

  // Update the selector title to make it seem like it's an regular dropdown
  jQuery(".selector__nav__title").text($this.html().replace(/&amp;/g, '&'));

  // Close the selector, otherwise it gets left open.
  var $loftSelector = jQuery('.selector__nav__title')
    $inner          = $loftSelector.parent();
  closeSelectorNavDropdown( $loftSelector, $inner );
}

function readMoreTimeline(event) {
  // Prevent the default click action from occuring
  event.preventDefault();

  var $this    = jQuery(this), // .read-more a
      $parent  = $this.parent(),  // .read-more
      $wrapper = $this.parent().parent(); // .wrapper

  // If the wrapper has the expanded class do nothing,
  // if it doesn't then expand out the timeline and remove
  // the read more link
  if( !$wrapper.hasClass('wrapper--expanded') ) {
    $wrapper.addClass('wrapper--expanded');

    $wrapper.slideDown(250, function() {
      $wrapper.css('height', 'auto');
    });

    $parent.remove();
	}
}

// Given a waypoint and element(s) animate them
function animateTheThings(waypoint, parentElement, individualElement) {
  //= Neighbors animation
  jQuery(waypoint).waypoint(function() {
    jQuery(parentElement).find(individualElement).each(function(e) {
      var $a = jQuery(this);

      // Timeout * e (each one of the steps) spaces out the animations
      // for each step so they drop in one by one
      setTimeout(function() {
        $a.addClass("animated fadeInDown");
      }, 150 * e);
    });
  }, {
    offset: 'bottom-in-view'
  });
}

jQuery(document).ready(function() {
  setupNav();
  setupGallery();

  // Initialize dropdown on collapsible archive widget
	jQuery('.selector__nav__title').on('click', selectorNavDropdown);
  jQuery('.selector__nav__inner ul a').on('click', selectorNavUpdate);

  // Read more timline on mobile
  jQuery('.page-home .read-more a').on('click', readMoreTimeline);

  //== Animate all the things!
  //= Timeline animation
  // - On screens sm and up animate the steps once the waypoint .map is hit
  animateTheThings(".page-home .map", ".your-day", ".step");
  animateTheThings(".page-home .amenities__list__complete", ".neighborhood", ".neighbor");
});
